document.addEventListener('DOMContentLoaded', function () {
  var zdUserInfo = {
    id: user.zeta_id,
    gender: user.zeta_gender,
    age: user.zeta_age,
  };
  zdSearchCondition = zetaParam;
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = zetaScriptUrl;
  document.getElementsByTagName('script')[0].parentNode.insertBefore(script, null);
});
